import React from "react";
import { Button, HStack, Link, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useColorModeValue } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import RiskReviewStatusBadge from "../common/RiskReviewStatusBadge";
import { formatDate } from "../../utils/riskReviewFormatters";

const latestVersion = (template) => [...(template.versions || [])].sort((a, b) => b.version - a.version)[0];
const publishedVersion = (template) => [...(template.versions || [])].filter((v) => v.status === "PUBLISHED").sort((a, b) => b.version - a.version)[0];

const RiskReviewTemplateTable = ({ templates = [], onCreateVersion }) => {
  const cardBg = useColorModeValue("white", "gray.800");
  const borderColor = useColorModeValue("gray.200", "gray.700");
  const headBg = useColorModeValue("gray.50", "gray.700");
  const hoverBg = useColorModeValue("gray.50", "gray.700");

  return (
    <TableContainer bg={cardBg} borderWidth="1px" borderColor={borderColor} borderRadius="md" boxShadow="sm">
      <Table size="sm">
        <Thead bg={headBg}>
          <Tr>
            <Th py={3}>Template</Th>
            <Th>Code</Th>
            <Th>Request Type</Th>
            <Th>Business Unit</Th>
            <Th>Country</Th>
            <Th>Published Version</Th>
            <Th>Status</Th>
            <Th>Updated</Th>
            <Th textAlign="right">Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {templates.map((template) => {
            const latest = latestVersion(template);
            const published = publishedVersion(template);
            return (
              <Tr key={template._id} _hover={{ bg: hoverBg }}>
                <Td py={3}>
                  <Link as={RouterLink} to={`/risk-review/templates/${template._id}`} fontWeight="semibold" color="blue.600" _dark={{ color: "blue.300" }}>
                    {template.name}
                  </Link>
                  <Text color="gray.500" fontSize="xs">
                    {template.code}
                  </Text>
                </Td>
                <Td>{template.code}</Td>
                <Td>{template.requestType || "Any"}</Td>
                <Td>{template.businessUnit || "Any"}</Td>
                <Td>{template.country || "Any"}</Td>
                <Td>{published ? `v${published.version}` : "—"}</Td>
                <Td>
                  <RiskReviewStatusBadge value={latest?.status || (template.active ? "DRAFT" : "INACTIVE")} type="template" />
                </Td>
                <Td>{formatDate(template.updatedAt || template.createdAt)}</Td>
                <Td textAlign="right">
                  <HStack justify="flex-end">
                    <Button as={RouterLink} to={`/risk-review/templates/${template._id}`} size="sm" variant="outline">
                      Open
                    </Button>
                    <Button size="sm" onClick={() => onCreateVersion?.(template._id)}>
                      Create Version
                    </Button>
                  </HStack>
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default RiskReviewTemplateTable;
